// extracted by mini-css-extract-plugin
export default {"brandPromo":"HH-z","carousel":"IH-z"};